var map = {
	"./bialystok/podatek-lesny/section-1_pl.mdx": [
		47381,
		47381
	],
	"./bydgoszcz/podatek-lesny/section-1_pl.mdx": [
		28142,
		28142
	],
	"./czestochowa/podatek-lesny/section-1_pl.mdx": [
		58771,
		58771
	],
	"./garwolin/podatek-lesny/section-1_pl.mdx": [
		40972,
		40972
	],
	"./gdansk/podatek-lesny/section-1_pl.mdx": [
		25477,
		25477
	],
	"./gdynia/podatek-lesny/section-1_pl.mdx": [
		53637,
		53637
	],
	"./gliwice/podatek-lesny/section-1_pl.mdx": [
		65389,
		65389
	],
	"./gmina-swidnica/podatek-lesny/section-1_pl.mdx": [
		57688,
		57688
	],
	"./kielce/podatek-lesny/section-1_pl.mdx": [
		38018,
		38018
	],
	"./kolobrzeg/podatek-lesny/section-1_pl.mdx": [
		34740,
		34740
	],
	"./konskowola/podatek-lesny/section-1_pl.mdx": [
		29525,
		29525
	],
	"./koszalin/podatek-lesny/section-1_pl.mdx": [
		87610,
		87610
	],
	"./lask/podatek-lesny/section-1_pl.mdx": [
		74694,
		74694
	],
	"./lodz/podatek-lesny/section-1_pl.mdx": [
		9960,
		9960
	],
	"./lublin/podatek-lesny/section-1_pl.mdx": [
		32085,
		32085
	],
	"./miejsce-piastowe/podatek-lesny/section-1_pl.mdx": [
		23220,
		23220
	],
	"./mikolow/podatek-lesny/section-1_pl.mdx": [
		56677,
		56677
	],
	"./naklo/podatek-lesny/section-1_pl.mdx": [
		94188,
		94188
	],
	"./oborniki/podatek-lesny/section-1_pl.mdx": [
		34682,
		34682
	],
	"./olesnica/podatek-lesny/section-1_pl.mdx": [
		85869,
		85869
	],
	"./postomino/podatek-lesny/section-1_pl.mdx": [
		1609,
		1609
	],
	"./poznan/podatek-lesny/section-1_pl.mdx": [
		9505,
		9505
	],
	"./przechlewo/podatek-lesny/section-1_pl.mdx": [
		18106,
		18106
	],
	"./radom/podatek-lesny/section-1_pl.mdx": [
		3436,
		3436
	],
	"./raszkow/podatek-lesny/section-1_pl.mdx": [
		78232,
		78232
	],
	"./rawicz/podatek-lesny/section-1_pl.mdx": [
		38775,
		38775
	],
	"./ryman/podatek-lesny/section-1_pl.mdx": [
		27520,
		27520
	],
	"./sierakowice/podatek-lesny/section-1_pl.mdx": [
		50099,
		50099
	],
	"./slawno/podatek-lesny/section-1_pl.mdx": [
		47643,
		47643
	],
	"./slawoborze/podatek-lesny/section-1_pl.mdx": [
		34369,
		34369
	],
	"./stare-babice/podatek-lesny/section-1_pl.mdx": [
		30769,
		30769
	],
	"./szczecin/podatek-lesny/section-1_pl.mdx": [
		58552,
		58552
	],
	"./szemud/podatek-lesny/section-1_pl.mdx": [
		78297,
		78297
	],
	"./warszawa/podatek-lesny/section-1_pl.mdx": [
		39397,
		39397
	],
	"./wloszczowa/podatek-lesny/section-1_pl.mdx": [
		88718,
		88718
	],
	"./wroclaw/podatek-lesny/section-1_pl.mdx": [
		91726,
		91726
	],
	"./wyszkow/podatek-lesny/section-1_pl.mdx": [
		31663,
		31663
	],
	"./zukowo/podatek-lesny/section-1_pl.mdx": [
		59466,
		59466
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 14712;
module.exports = webpackAsyncContext;